import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../shared/auth/AuthContext';
import { hasAdminAccess } from '../shared/auth/authorization';
import './Layout.css';

const WORKFLOW_PATHS = new Set(['/', '/kiosk', '/tpn-bookings', '/pallet-registrations']);

const NAV_ITEMS = [
 // { to: '/kiosk', label: 'สถานีขั่งน้ำหนัก', icon: '/scale_icon.svg' },
 // { to: '/tpn-bookings', label: 'รายการจอง', icon: '\uD83D\uDCCB' },
  { to: '/register-bindings', label: 'ทะเบียนสถานี', icon: '\uD83D\uDDA5\uFE0F' , requiresAdmin: true },
  { to: '/devices', label: 'ทะเบียนอุปกรณ์', icon: '\uD83D\uDEE0\uFE0F' , requiresAdmin: true },
  //{ to: '/pallet-registrations', label: 'ทะเบียนพาเลท', icon: '\uD83D\uDCE6' },
  { to: '/tpn-vehicles', label: 'ยานพาหนะ', icon: '\uD83D\uDE9B',requiresAdmin: true  },
  { to: '/weighing-submit', label: 'ทดสอบส่งค่า', icon: '⚡', requiresAdmin: true  },
];

function BrandLogo() {
  return (
    <Link to="/kiosk" className="sidebar-logo" aria-hidden="true">
      <img src="/factory.svg" alt="" className="sidebar-logo-image" />
    </Link>
  );
}

export default function Layout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const { pathname } = useLocation();
  const useWorkflowLayout = WORKFLOW_PATHS.has(pathname);
  const { user } = useAuth();
  const visibleNavItems = NAV_ITEMS.filter((item) => !item.requiresAdmin || hasAdminAccess(user));

  useEffect(() => {
    if (!mobileNavOpen) {
      return undefined;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [mobileNavOpen]);

  function closeMobileNav() {
    setMobileNavOpen(false);
  }

  return (
    <div className={`app-layout${useWorkflowLayout ? ' app-layout-workflow' : ''}`}>
      <div className="mobile-topbar">
        <button
          type="button"
          className="mobile-menu-btn"
          onClick={() => setMobileNavOpen((current) => !current)}
          aria-label={mobileNavOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={mobileNavOpen}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="mobile-topbar-brand">
          <BrandLogo />
          <div>
            <span className="sidebar-title">TPN</span>
            <span className="sidebar-subtitle">Factory</span>
          </div>
        </div>
      </div>

      <button
        type="button"
        className={`sidebar-overlay${mobileNavOpen ? ' open' : ''}`}
        onClick={closeMobileNav}
        aria-label="Close navigation menu"
      />

      <aside className={`sidebar${mobileNavOpen ? ' sidebar-open' : ''}`}>
        <div className="sidebar-brand">
          <BrandLogo />
          <div>
            <span className="sidebar-title">TPN</span>
            <span className="sidebar-subtitle">Factory</span>
          </div>
        </div>
        <nav className="sidebar-nav">
          {visibleNavItems.map(({ to, label, icon }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}
              onClick={closeMobileNav}
            >
              <span className="sidebar-link-icon" aria-hidden="true">
                {icon.startsWith('/') ? (
                  <img src={icon} alt="" className="sidebar-link-icon-image" />
                ) : (
                  icon
                )}
              </span>
              {label}
            </NavLink>
          ))}
        </nav>
        {user && (
          <div className="sidebar-user">
            <span className="sidebar-user-name" title={user.email ?? user.name}>{user.name ?? user.email}</span>
            <Link to="/user-detail" className="sidebar-profile-btn" onClick={closeMobileNav}>ข้อมูลผู้ใช้</Link>
            <a href="/api/auth/logout" className="sidebar-logout-btn">ออกจากระบบ</a>
          </div>
        )}
      </aside>
      <div className="app-main">
        <Outlet />
      </div>
    </div>
  );
}
